import gql from "../gql";
export default gql `
  fragment Category on Category {
    __typename
    apiName
    name
    position
  }
`;
